import React, { Component } from "react";
import Dropzone from "react-dropzone";
import Alert from "/src/util/alert";

import Modal from "./../../component/Modal";
import { DOCUMENTS } from "../../config/lang";

import { call, upload } from "../../util/action";
import { translate } from "../../util/util";
import { dateTimeCreated } from "./../../util/formatter";

const PAGE_SIZE = 25;

class View extends Component {
  _debounce = null;

  constructor(props) {
    super(props);

    this.state = {
      file: null,
      name: "",

      list: [],
      count: 0,
      loading: false,

      search: "",
      ordering: "-created",
      page: 1,

      errors: [],
      isModal: false,
    };
  }

  onDrop = files => {
    this.setState({ files });
  };

  componentDidMount() {
    this.load();
  }

  load = () => {
    const { page, search, ordering } = this.state;
    const parts = [`page=${page}`, `page_size=${PAGE_SIZE}`];
    if (search) parts.push(`search=${encodeURIComponent(search)}`);
    if (ordering) parts.push(`ordering=${encodeURIComponent(ordering)}`);
    call({ method: "GET", url: `documents/?${parts.join("&")}` }, r => {
      this.setState({ list: (r && r.results) || [], count: (r && r.count) || 0 });
    });
  };

  onSearch = e => {
    const search = e.target.value;
    this.setState({ search, page: 1 });
    clearTimeout(this._debounce);
    this._debounce = setTimeout(this.load, 500);
  };

  toggleSort = key => {
    this.setState(s => ({ ordering: s.ordering === key ? "-" + key : key, page: 1 }), this.load);
  };

  sortArrow = key => (this.state.ordering === key ? " ↑" : this.state.ordering === "-" + key ? " ↓" : "");

  goPage = page => this.setState({ page }, this.load);

  delete = id => {
    const lang = this.props.currentUser.language;
    call({ method: "DELETE", url: "documents/" + id + "/" }, r => {
      Alert.success(translate(DOCUMENTS, "file_deleted", lang), { position: "bottom-right" });
      this.load();
    });
  };

  validate = () => {
    let errors = [];
    const lang = this.props.currentUser.language;

    if (!this.state.name) {
      errors.push(translate(DOCUMENTS, "file_name_cannot_be_empty", lang));
    }

    if (!this.state.file) {
      errors.push(translate(DOCUMENTS, "need_to_add_file", lang));
    }

    this.setState({ errors: errors });

    return errors.length == 0;
  };

  submit = () => {
    const lang = this.props.currentUser.language;

    if (this.validate()) {
      var formData = new FormData();
      formData.append("document", this.state.file);
      formData.append("title", this.state.name);

      upload({ method: "POST", url: "documents/", post: formData }, r => {
        Alert.success(translate(DOCUMENTS, "file_successfully_uploaded", lang), { position: "bottom-right" });
        this.setState({ file: null, name: "", isModal: false });
        this.load();
      });
    }
  };

  uploadFile = acceptedFiles => {
    this.setState({ file: acceptedFiles[0] });
  };

  onChange = (property, value) => {
    let state = this.state;
    state[property] = value;
    this.setState(state);
  };

  modalClose = () => {
    this.setState({ isModal: false });
  };

  getFileExtension = (url) => {
    if (!url) return "";
    const name = url.split("/").pop().split("?")[0];
    const ext = name.split(".").pop().toLowerCase();
    return ext;
  };

  getFileIcon = (url) => {
    const ext = this.getFileExtension(url);
    const map = {
      pdf: "picture_as_pdf",
      doc: "description",
      docx: "description",
      xls: "table_chart",
      xlsx: "table_chart",
      csv: "table_chart",
      png: "image",
      jpg: "image",
      jpeg: "image",
      gif: "image",
      svg: "image",
      zip: "folder_zip",
      rar: "folder_zip",
    };
    return map[ext] || "draft";
  };

  render() {
    let { file, isModal } = this.state;
    const { currentUser } = this.props;
    const pages = Math.max(1, Math.ceil(this.state.count / PAGE_SIZE));
    return (
      <div className="container-fluid doc-page">
        <div className="box p-4 doc-page-card">
          <div className="doc-top-bar">
            <input
              type="text"
              className="doc-search-input"
              placeholder={translate(DOCUMENTS, "search", currentUser.language)}
              value={this.state.search}
              onChange={this.onSearch}
            />
            <button className="doc-add-btn" onClick={() => this.setState({ isModal: true })}>
              <span className="material-symbols-outlined">upload_file</span>
              {translate(DOCUMENTS, "add_file", currentUser.language)}
            </button>
          </div>

          <Modal isShow={isModal} onClose={() => this.modalClose()}>
            <div className="doc-modal">
              <h3 className="doc-modal-title">
                <span className="material-symbols-outlined">upload_file</span>
                {translate(DOCUMENTS, "add_file", currentUser.language)}
              </h3>

              <div className="doc-modal-field">
                <label className="doc-modal-label">{translate(DOCUMENTS, "file_name", currentUser.language)}</label>
                <input
                  type="text"
                  className="doc-modal-input"
                  placeholder={translate(DOCUMENTS, "file_name", currentUser.language)}
                  value={this.state.name}
                  onChange={e => this.onChange("name", e.target.value)}
                />
              </div>

              <Dropzone onDrop={this.uploadFile} styles={{ dropzone: { minHeight: 150, maxHeight: 250 } }}>
                {({ getRootProps, getInputProps }) => (
                  <div className="doc-dropzone" {...getRootProps()}>
                    <input {...getInputProps()} />
                    <span className="material-symbols-outlined doc-dropzone-icon">cloud_upload</span>
                    <p className="doc-dropzone-text">{translate(DOCUMENTS, "click_or_drag_files_here", currentUser.language)}</p>
                    {file && (
                      <div className="doc-dropzone-file">
                        <span className="material-symbols-outlined">attach_file</span>
                        {file.name}
                      </div>
                    )}
                  </div>
                )}
              </Dropzone>

              {this.state.errors.length > 0 && (
                <div className="doc-modal-errors">
                  {this.state.errors.map(i => (
                    <span key={i} className="doc-modal-error">{i}</span>
                  ))}
                </div>
              )}

              <button className="doc-modal-submit" onClick={() => this.submit()}>
                <span className="material-symbols-outlined">upload</span>
                {translate(DOCUMENTS, "download_file_btn", currentUser.language)}
              </button>
            </div>
          </Modal>

          <div className="doc-table-wrap">
            <table className="doc-table">
              <thead>
                <tr>
                  <th className="doc-sortable" onClick={() => this.toggleSort("title")}>
                    {translate(DOCUMENTS, "file_name", currentUser.language)}
                    <span className="doc-sort-arrow">{this.sortArrow("title")}</span>
                  </th>
                  <th className="doc-sortable" onClick={() => this.toggleSort("created")}>
                    {translate(DOCUMENTS, "creation_time", currentUser.language)}
                    <span className="doc-sort-arrow">{this.sortArrow("created")}</span>
                  </th>
                  <th style={{ width: "120px" }}></th>
                </tr>
              </thead>
              <tbody>
                {this.state.list.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <div className="doc-file-cell">
                        <span className={`material-symbols-outlined doc-file-icon doc-file-icon--${this.getFileExtension(item.document)}`}>
                          {this.getFileIcon(item.document)}
                        </span>
                        <span className="doc-file-name">{item.title}</span>
                      </div>
                    </td>
                    <td>
                      <span className="doc-date">{dateTimeCreated(item)}</span>
                    </td>
                    <td>
                      <div className="doc-actions">
                        <a href={item.document} target="_blank" className="doc-action-btn doc-action-btn--download" title="Download">
                          <span className="material-symbols-outlined">download</span>
                        </a>
                        <button className="doc-action-btn doc-action-btn--delete" onClick={() => this.delete(item.id)} title="Delete">
                          <span className="material-symbols-outlined">delete</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
                {this.state.list.length === 0 && (
                  <tr>
                    <td colSpan="3">
                      <div className="doc-empty">
                        <span className="material-symbols-outlined">folder_open</span>
                        <p>No documents yet</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {this.state.count > PAGE_SIZE && (
            <div className="doc-pagination">
              <button disabled={this.state.page <= 1} onClick={() => this.goPage(this.state.page - 1)}>
                ‹
              </button>
              <span>
                {this.state.page} / {pages}
              </span>
              <button disabled={this.state.page >= pages} onClick={() => this.goPage(this.state.page + 1)}>
                ›
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default View;
